import Sungrow from '@src/assets/clients/sungrow.png'
import Lighthouse from '@src/assets/clients/lighthouse.png'
import SaresRegis from '@src/assets/clients/srg.svg'
import CBRE from '@src/assets/clients/cbre.svg'
import JLL from '@src/assets/clients/jll.svg'
import type { ClientLogo } from '@src/pages/LandingPage/Clients'

/**
 * Curated client logos for the solar pages, passed to <Clients clients={...} />.
 * Mirrors the five-logo row on the React solar landing pages.
 */
const solarClients: ClientLogo[] = [
  { src: Sungrow.src, alt: 'Sungrow logo' },
  { src: Lighthouse.src, alt: 'Lighthouse logo' },
  { src: SaresRegis.src, alt: 'Sares Regis Group logo' },
  { src: CBRE.src, alt: 'CBRE logo' },
  { src: JLL.src, alt: 'JLL logo' },
]

export default solarClients
